import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Select, Tooltip } from 'antd';

import useParentServices from '../../../../Statistics/queries/useParentServices';
import useServices from '../../../../Statistics/queries/useServices';
import { dspxGetChildrens } from '../../../../../helpers/dspx-utils';

export const ServiceField = React.forwardRef(
  ({ value, onChange, loading, disabled, ...props }, ref) => {
    const [parent, sub] = value || [];
    const [selectedParentServices, setSelectedParentServices] = useState(
      parent || []
    );
    const [selectedSubServices, setSelectedSubServices] = useState(sub || []);

    useEffect(() => {
      onChange([selectedParentServices, selectedSubServices]);
      /* eslint-disable react-hooks/exhaustive-deps */
    }, [
      onChange,
      JSON.stringify(selectedParentServices),
      JSON.stringify(selectedSubServices),
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */

    const changeSelectedSubServices = (value = []) => {
      setSelectedSubServices(value);
    };
    const changeSelectedParentServices = (value = []) => {
      selectedSubServices.length && changeSelectedSubServices([]);
      setSelectedParentServices(value);
    };

    const parentServicesQuery = useParentServices({
      options: {
        staleTime: Infinity,
        initialData: [],
      },
    });
    if (!parentServicesQuery.data?.length && !parentServicesQuery.isFetched) {
      parentServicesQuery.refetch();
    }
    const subServicesQuery = useServices(selectedParentServices || [], {
      staleTime: Infinity,
      initialData: [],
    });
    if (selectedParentServices.length && !subServicesQuery.isFetched) {
      subServicesQuery.refetch();
    }

    const parentService = useMemo(() => {
      return dspxGetChildrens(parentServicesQuery?.data || []);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(parentServicesQuery.data)]);

    const childrenSubservice = useMemo(() => {
      const listSubservice = subServicesQuery?.data || [];
      // TODO: вынести в отдельную функцию
      return Array.isArray(listSubservice)
        ? listSubservice.reduce((pre, el) => {
            let ret = pre;
            if (!ret) ret = [];

            if (!ret.length || +ret[ret.length - 1].key !== el.parentId) {
              ret.push(
                React.createElement(
                  Select.OptGroup,
                  { key: el.parentId, label: el.parentName },
                  []
                )
              );
            }

            ret[ret.length - 1].props.children.push(
              el.name.length > 30 ? (
                <Select.Option
                  key={el.id}
                  searchtext={el.name}
                >
                  <Tooltip title={el.name}>{el.name}</Tooltip>
                </Select.Option>
              ) : (
                <Select.Option
                  key={el.id}
                  searchtext={el.name}
                >
                  {el.name}{' '}
                </Select.Option>
              )
            );

            return ret;
          }, [])
        : [];
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(subServicesQuery.data)]);

    return (
      <Input.Group
        compact
        {...{ style: props.style }}
      >
        <Select
          mode="multiple"
          defaultActiveFirstOption={false}
          allowClear={true}
          style={{ width: '40%' }}
          placeholder="услуга"
          notFoundContent="нет данных"
          value={selectedParentServices}
          onChange={changeSelectedParentServices}
          optionFilterProp="searchtext"
          loading={loading || parentServicesQuery?.isFetching}
          disabled={disabled}
        >
          {parentService}
        </Select>

        <Select
          mode="multiple"
          defaultActiveFirstOption={false}
          allowClear={true}
          style={{ width: '60%' }}
          placeholder="причина"
          notFoundContent="нет данных"
          value={selectedSubServices}
          onChange={changeSelectedSubServices}
          optionFilterProp="searchtext"
          loading={loading || subServicesQuery?.isFetching}
          disabled={disabled}
        >
          {childrenSubservice}
        </Select>
      </Input.Group>
    );
  }
);

ServiceField.propTypes = {
  value: PropTypes.array,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

ServiceField.defaultProps = {
  value: [[], []],
};
